<template>
  <div id="AppContainer" :style="appHeight">
    <v-app :class="themeClass">
      <k-top-menu></k-top-menu>
      <v-main>
        <transition
          :name="pageTransition.name"
          :mode="pageTransition.mode"
          @after-leave="AfterLeave"
          @after-enter="AfterEnter"
        >
          <keep-alive :include="['Fooldal']">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </v-main>
      <modal-handler></modal-handler>
      <k-bottom-bar
        v-if="layoutWithBottomBar && bottomBarVisible && isMobile"
      ></k-bottom-bar>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from './functions/AppFunctions';
import settings from './settings';
import { AppStoreTypes } from './store/modules/app';

const DEFAULT_TRANSITION = 'fade';
export default {
  name: 'app',
  data() {
    return {
      settings,
    };
  },
  created() {
    AppFunctions.HandleParams();
    this.$router.beforeEach((to, from, next) => {
      next();
    });
  },
  async mounted() {
    await this.$nextTick();
    AppFunctions.SetApplicationTheme(this.projektBgColor);
  },
  methods: {
    AfterEnter() {
      document.getElementById('AppContainer').scrollTo(0, 0);
    },
    AfterLeave() {
      this.$store.dispatch(AppStoreTypes.pageTransition.set, {
        value: {
          name: 'router-view',
          mode: 'in-out',
        },
      });
    },
    LoadCss() {
      let egyediCss = document.getElementById('egyedi-css');
      if (egyediCss) {
        egyediCss.remove();
      }
      if (!this.cssSrc) {
        return;
      }
      let cssSrc = this.cssSrc;
      let styleTag = document.createElement('link');
      styleTag.id = 'egyedi-css';
      styleTag.type = 'text/css';
      styleTag.rel = 'stylesheet';
      styleTag.href = cssSrc;
      document.head.appendChild(styleTag);
    },
  },
  computed: {
    ...mapGetters({
      pageTransition: AppStoreTypes.pageTransition.get,
      user: AppStoreTypes.user.get,
    }),
    layoutWithBottomBar() {
      if (
        this.$route.name == 'NoPermission' ||
        this.$route.name == 'PrivateSite' ||
        this.$route.name == 'MegosztottHir' ||
        this.user?.Id == -1
      ) {
        return false;
      }
      return true;
    },
    bottomBarVisible() {
      return AppFunctions.GetAppData(this.$store).bottomBar;
    },
    appHeight() {
      let bottomNavHeight = this.$vuetify.application.bottom;
      //prettier-ignore
      return 'height: 100vh; overflow-y: auto; -webkit-overflow-scrolling: touch !important;';
    },
    themeClass() {
      if (settings.env == 'ovf') {
        return 'blue-theme';
      } else {
        return 'purple-theme';
      }
    },
    projekt() {
      return this.user?.Projekt;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    cssSrc() {
      if (!this.projekt?.CssFajlNeve) {
        return null;
      }
      return (
        settings.baseUrl +
        'Api/Projekt/GetCssContentByProjectId/?projectId=' +
        this.projekt.Id
      );
    },
    projektBgColor() {
      return this.projekt?.Hatterszin1 || '#FFFFFF';
    },
  },
  watch: {
    projekt: {
      async handler() {
        await this.$nextTick();
        document.title = this.projekt?.Nev ?? 'StreamNext';

        if (this.projekt) {
          this.LoadCss();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$duration: 0.3s;
.transition {
  overflow: hidden;
}
.router-view,
.router-view-back {
  &-enter-active,
  &-leave-active {
    position: fixed;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 0;
  }
}
// router view
.router-view-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.router-view-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.router-view-leave-active {
  z-index: -1;
}
.router-view-leave-to {
  z-index: -1;
}
// router view back

.router-view-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.router-view-back-leave-to {
  z-index: 2;
  transform: translateX(100%);
}
</style>
